import _ from "lodash";
import React from "react";

import { modalForms } from "./component-properties/decide";
import { DYNAMICLIST, GRID, LINKEDLIST } from "./constants";
import { getUnitPropertie } from "../../smart/camunda/forms/functions";
import IframeForm from "../../smart/camunda/IframeForm";

// Método que retorna a propriedade DEFAULT VALUE
export function findObjectDefaultValue(state, propertieId) {
  const object =
    state &&
    state.properties &&
    state.properties.find((item) => item.id === propertieId);
  return object;
}

// Método que retorna a index da propriedade DEFAULT VALUE
export function findIndexDefaultValue(state, propertieId) {
  const index =
    state &&
    state.properties &&
    state.properties.findIndex((item) => item.id === propertieId);
  return index;
}

// Método que renderiza o preview do componente
export const renderPreview = (item) => {
  const formData = {
    isSignatureTask: false,
    form: [{ [item.name]: item }],
    variables: {},
  };

  if (!formData.form.length) return null;
  return <IframeForm formData={formData} onSubmit={() => null} previewMode />;
};

// Método para retornar o conteúdo das Tabs
export const getTabContent = (type, item) => {
  if (item) {
    const typeIsObject = !!item?.type?.name;
    if (typeIsObject) {
      const contentObject = modalForms[item.type.name][type];

      if (contentObject) return contentObject;
      return false;
    }
    const content = modalForms[item.type]?.[type];

    if (content) return content;
    return false;
  }
  return false;
};

// Método lodash para busca da propriedade por nome
export function getPropertieObjectById(props, name) {
  return _.find(props, function (a) {
    return a.id === name;
  });
}

//Método que cria o objeto do tipo grid
export const createGrid = (item) => {
  const clonedObject = Object.assign({}, item);
  //pega o valor default caso a propriedade 'rows' não seja encontrada
  let rows =
    clonedObject.properties &&
    clonedObject.properties.find((i) => i.id === "rows");
  !rows &&
    clonedObject.properties.push({
      id: "rows",
      value: clonedObject.rows,
      text: "rows",
      type: "text",
    });
  rows = rows ? rows.value : clonedObject.rows;

  //pega o valor default caso a propriedade 'columns' não seja encontrada
  let columns =
    clonedObject.properties &&
    clonedObject.properties.find((i) => i.id === "columns");
  !columns &&
    clonedObject.properties.push({
      id: "columns",
      value: clonedObject.columns,
      text: "columns",
      type: "text",
    });
  columns = columns ? columns.value : clonedObject.columns;

  //

  //clonedObject.rows = rows;
  //clonedObject.columns = columns;

  for (let i = 0; i < rows; i++) {
    const row = {
      id: `${clonedObject.id}-tr-${i}`,
      type: "gridRow",
      items: [],
    };
    for (let c = 0; c < columns; c++) {
      const column = {
        id: `${clonedObject.id}-td-${i}`,
        type: "gridColumn",
        items: [],
      };
      row.items.push(column);
    }
    clonedObject.items.push(row);
  }
  return clonedObject;
};

//Método que atualiza a quantidade de linhas e colunas do grid
export const updateGrid = (item) => {
  const clonedObject = Object.assign({}, item);
  //pega o valor default caso a propriedade 'rows' não seja encontrada
  let rows =
    clonedObject.properties &&
    clonedObject.properties.find((i) => i.id === "rows");
  rows = rows ? rows.value : clonedObject.rows;

  //pega o valor default caso a propriedade 'columns' não seja encontrada
  let columns =
    clonedObject.properties &&
    clonedObject.properties.find((i) => i.id === "columns");
  columns = columns ? columns.value : clonedObject.columns;

  clonedObject.rows = rows;
  clonedObject.columns = columns;

  //adiciona items ja existente no grid
  const oldItems = clonedObject.items;
  clonedObject.items = [];

  for (let i = 0; i < rows; i++) {
    const currentLine = oldItems[i];
    const oldColumns = currentLine && currentLine.items;
    const newRow = currentLine || {
      id: `${clonedObject.id}-tr-${i}`,
      type: "gridRow",
      items: [],
    };
    newRow.items = [];
    for (let c = 0; c < columns; c++) {
      const currentColumn = oldColumns && oldColumns[c];
      const newColumn = currentColumn || {
        id: `${clonedObject.id}-td-${i}`,
        type: "gridColumn",
        items: [],
      };
      newRow.items.push(newColumn);
    }
    clonedObject.items.push(newRow);
  }
  return clonedObject;
};

//remove item do grid
export const removeItemFromGrid = (item, allItems) => {
  function getChildElement(nodes, id) {
    for (let i = 0; i < nodes.length; i++) {
      let child = nodes[i];
      if (child.uuid === id) {
        nodes.splice(i, 1);
        return child;
      }
      if (!child.items) {
        continue;
      }
      child = getChildElement(child.items, id);
      if (child !== null) {
        return child;
      }
    }
    return null;
  }

  if (!item) {
    return allItems;
  }

  const newArray = Array.from(allItems);
  for (let i = 0; i < newArray.length; i++) {
    if (newArray[i].type === GRID || newArray[i].type === DYNAMICLIST) {
      if (getChildElement(newArray[i].items, item.uuid)) break;
    }
  }

  return newArray;
};

//edita item no grid
export const editItemOnGrid = (item, allItems) => {
  function getChildElement(nodes, id) {
    for (let i = 0; i < nodes.length; i++) {
      let child = nodes[i];
      if (child.uuid === id) {
        nodes[i] = item;
        return child;
      }
      if (!child.items) {
        continue;
      }
      child = getChildElement(child.items, id);
      if (child !== null) {
        return child;
      }
    }
    return null;
  }

  const newArray = Array.from(allItems);
  for (let i = 0; i < newArray.length; i++) {
    if (newArray[i].type === GRID || newArray[i].type === DYNAMICLIST) {
      if (getChildElement(newArray[i].items, item.uuid)) break;
    }
  }

  return newArray;
};

//retorna item que está grid
export const findItemOnGrid = (item, allItems) => {
  function getChildElement(nodes, id) {
    for (let i = 0; i < nodes.length; i++) {
      let child = nodes[i];
      if (child.uuid === id) {
        return child;
      }
      if (!child.items) {
        continue;
      }
      child = getChildElement(child.items, id);
      if (child !== null) {
        return child;
      }
    }
    return null;
  }

  const newArray = Array.from(allItems);
  let value;
  for (let i = 0; i < newArray.length; i++) {
    if (newArray[i].type === GRID || newArray[i].type === DYNAMICLIST) {
      value = getChildElement(newArray[i].items, item.uuid);
      if (value) break;
    }
  }
  return value;
};

//Método que reseta o objeto movido do menu de campos
export const resetMenuField = (object, index) => {
  const resetedObject = Object.assign({}, object);

  Object.keys(resetedObject).forEach((e, index) => {
    if (e === "style") {
      resetedObject[e] = {};
    } else if (e === "properties") {
      //se o tipo for 'LinkedList', então adiciona o array default da lista dentro de properties
      if (object.type === LINKEDLIST) {
        resetedObject[e] = [
          {
            id: "lista",
            type: "lista",
            value: {
              lista: [
                {
                  id: "default",
                  value: "default",
                  uuid: "129102991209xxxxx2default",
                  label: "Default",
                  lista: [],
                },
              ],
              type: LINKEDLIST,
            },
          },
        ];
      } else {
        resetedObject[e] = [];
      }
    } else if (e === "items") {
      resetedObject[e] = [];
    }
  });
  return resetedObject;
};

export const llFindChildrenById = (nodes, id) => {
  for (let i = 0; i < nodes.length; i++) {
    let child = nodes[i];

    if (child.uuid === id) {
      return child;
    }
    if (!child.lista) {
      continue;
    }

    child = llFindChildrenById(child.lista, id);

    if (child !== null) {
      return child;
    }
  }
  return null;
};

export const llDeleteNodeById = (nodes, id) => {
  for (let i = 0; i < nodes.length; i++) {
    let child = nodes[i];

    if (child.uuid === id) {
      nodes.splice(i, 1);
      return child;
    }
    if (!child.lista) {
      continue;
    }

    child = llDeleteNodeById(child.lista, id);

    if (child !== null) {
      return child;
    }
  }
  return null;
};

export const llEditNodeById = (nodes, obj, id) => {
  for (let i = 0; i < nodes.length; i++) {
    let child = nodes[i];

    if (child.uuid === id) {
      nodes[i].id = obj.id;
      nodes[i].label = obj.text;
      return child;
    }
    if (!child.lista) {
      continue;
    }

    child = llEditNodeById(child.lista, obj, id);

    if (child !== null) {
      return child;
    }
  }
  return null;
};

export const mergeValuesFromPropertie = (pp1, pp2, state) => {
  const p1 = getUnitPropertie(state, pp1);
  const p2 = getUnitPropertie(state, pp2);

  let merge = [];

  function arrayUnique(array) {
    const a = array.concat();
    for (let i = 0; i < a.length; ++i) {
      for (let j = i + 1; j < a.length; ++j) {
        if (a[i].id === a[j].id) a.splice(j--, 1);
      }
    }

    return a;
  }

  p1 && p2 && (merge = arrayUnique(p1.concat(p2)));

  if (p1 && p2) merge = arrayUnique(p1.concat(p2));
  else if (p1 && !p2) merge = p1;
  else if (p2 && !p1) merge = p2;

  return merge;
};

export const deleteValueFromPropertie = (pp1, state) => {
  const p1 = getUnitPropertie(state, pp1);

  const values = p1;

  values &&
    values.map((item) => {
      return values.splice(item, 1);
    });

  if (values !== p1) {
    return values;
  }
  return false;
};

export const getDocumentoVariables = (lines) => {
  const docVars = [];

  if (lines && lines.length > 0) {
    for (let i = 0; i < lines.length; i++) {
      const lineItem = lines[i];

      if (lineItem) {
        if (
          lineItem.type?.name === "Documento" ||
          lineItem.type === "Documento" ||
          lineItem.type?.name === "Minuta" ||
          lineItem.type === "Minuta" ||
          lineItem.type?.name === "MultDocsUpload" ||
          lineItem.type === "MultDocsUpload"
        ) {
          let label = lineItem.name ? lineItem.name : lineItem.label;

          if (!label && lineItem.properties) {
            label = getUnitPropertie(lineItem.properties, "label");
          }

          docVars.push({
            id: lineItem.id,
            name: label,
            type: lineItem.type,
            uuid: lineItem.uuid,
          });
          continue;
        }

        if (lineItem.type?.name === "Grid" || lineItem.type === "Grid") {
          if (lineItem?.items && lineItem?.items.length > 0) {
            for (let r = 0; r < lineItem.items.length; r++) {
              const gridRow = lineItem.items[r];

              if (gridRow?.items && gridRow?.items.length > 0) {
                for (let c = 0; c < gridRow.items.length; c++) {
                  const gridColumn = gridRow.items[c];

                  if (gridColumn?.items && gridColumn?.items.length > 0) {
                    for (let v = 0; v < gridColumn.items.length; v++) {
                      const gridValue = gridColumn.items[v];

                      if (
                        gridValue?.type?.name === "Documento" ||
                        gridValue?.type === "Documento" ||
                        gridValue.type?.name === "Minuta" ||
                        gridValue.type === "Minuta"
                      ) {
                        let label = lineItem.name
                          ? lineItem.name
                          : lineItem.label;

                        if (!label && lineItem.properties) {
                          label = getUnitPropertie(
                            lineItem.properties,
                            "label",
                          );
                        }

                        docVars.push({
                          id: gridValue.id,
                          name: label,
                          type: gridValue.type,
                          uuid: gridValue.uuid,
                        });
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  return docVars;
};
